import { WorkspacePanelTypeEnumType } from '@mark43/cad-api';
import { useBootstrapState, UseBootstrapStateReturns } from '../bootstrap/bootstrap-provider';

// Map to translate panel types to bootstrap fields.
const panelTypeToLimitFieldMap: Partial<
    Record<WorkspacePanelTypeEnumType, keyof UseBootstrapStateReturns>
> = {
    EVENT: 'limitOpenEventPanelCount',
};

export function useGetOpenPanelLimit() {
    const bootstrapState = useBootstrapState();

    return function getOpenPanelLimit(workspacePanelType: WorkspacePanelTypeEnumType) {
        const bootstrapField = panelTypeToLimitFieldMap[workspacePanelType];
        if (!bootstrapField) {
            return null;
        }
        const limit = bootstrapState[bootstrapField];
        return typeof limit === 'number' ? limit : null;
    };
}
